import withSecurity from 'views/enhancers/withSecurity'
import loadable from 'loadable-components'
import { TYPES } from 'constants/user'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: loadable(() => import('views/pages/Login')),
    exact: true,
    display: true,
    sitemap: true,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: loadable(() => import('views/pages/Privacy')),
    sitemap: true,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: loadable(() => import('views/pages/Contact')),
    exact: true,
    display: true,
    sitemap: true,
  },
  {
    path: '/register',
    name: 'Register',
    component: loadable(() => import('views/pages/Register')),
    sitemap: true,
  },
  {
    path: '/confirm/:origin/:token',
    name: 'Confirm',
    component: loadable(() => import('views/pages/Confirm')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: loadable(() => import('views/pages/Login')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: loadable(() => import('views/pages/Forgot')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/password/:token',
    name: 'Password',
    component: loadable(() => import('views/pages/Password')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: loadable(() => import('views/pages/Logout')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/account',
    name: 'Account',
    component: withSecurity(
      loadable(() => import('views/pages/Account')),
      false,
      [
        TYPES.FREIGHT_FORWARDER,
        TYPES.MANAGER,
        TYPES.OPERATOR,
        TYPES.ACCOUNTANT,
        TYPES.INDEPENDENT_COURIER,
        TYPES.COMPANY_COURIER,
      ],
    ),
    exact: true,
    display: true,
    sitemap: true,
  },
  {
    path: '/vouchers',
    name: 'Vouchers',
    component: withSecurity(
      loadable(() => import('views/pages/Vouchers')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
  },
  {
    path: '/bank',
    name: 'Bank',
    component: withSecurity(
      loadable(() => import('views/pages/Bank')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
  },
  {
    path: '/company',
    name: 'Company',
    component: withSecurity(
      loadable(() => import('views/pages/Company')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
  },
  {
    path: '/vehicles',
    name: 'My vehicles',
    component: withSecurity(
      loadable(() => import('views/pages/Vehicles')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR],
    ),
    exact: true,
  },
  {
    path: '/delivery',
    name: 'Delivery',
    component: withSecurity(
      loadable(() => import('views/pages/Delivery')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.INDEPENDENT_COURIER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/delivery/:id',
    name: 'DeliveryUpdate',
    component: withSecurity(
      loadable(() => import('views/pages/DeliveryUpdate')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/delivery-from-favourite/:id',
    name: 'DeliveryFromFavourite',
    component: withSecurity(
      loadable(() => import('views/pages/DeliveryFromFavourite')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/delivery/:id/:tab',
    name: 'DeliveryInfo',
    component: withSecurity(
      loadable(() => import('views/pages/DeliveryInfo')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/scheduled/:id/:tab',
    name: 'ScheduledInfo',
    component: withSecurity(
      loadable(() => import('views/pages/DeliveryInfo')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/search/:courier/:id/:tab',
    name: 'DeliveryInfo',
    component: withSecurity(
      loadable(() => import('views/pages/DeliveryInfo')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/retry/:id',
    name: 'Retry',
    component: withSecurity(
      loadable(() => import('views/pages/Retry')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/deliveries/:tab',
    name: 'Deliveries',
    component: withSecurity(
      loadable(() => import('views/pages/Deliveries')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/proposals/:tab',
    name: 'Proposals',
    component: withSecurity(
      loadable(() => import('views/pages/Proposals')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/favourites',
    name: 'Favourites',
    component: withSecurity(
      loadable(() => import('views/pages/Favourites')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/favourite',
    name: 'Favourite',
    component: withSecurity(
      loadable(() => import('views/pages/Favourite')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/favourite/:id',
    name: 'FavouriteModify',
    component: withSecurity(
      loadable(() => import('views/pages/Favourite')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/archives',
    name: 'Archives',
    component: withSecurity(
      loadable(() => import('views/pages/Archives')),
      false,
      [TYPES.FREIGHT_FORWARDER, TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/couriers',
    name: 'Couriers',
    component: withSecurity(
      loadable(() => import('views/pages/Couriers')),
      false,
      [TYPES.MANAGER, TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: true,
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: loadable(() => import('views/pages/Sitemap')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/tos/:verify?',
    name: 'TOS',
    component: loadable(() => import('views/pages/TOS')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy policy',
    component: loadable(() => import('views/pages/PrivacyPolicy')),
    exact: true,
    sitemap: true,
  },
  {
    path: '/admin/users/:id/validate',
    name: 'Admin user validate',
    component: withSecurity(
      loadable(() => import('views/pages/AdminUserValidate')),
      true,
    ),
    exact: true,
  },
  {
    path: '/operations',
    name: 'Operations',
    component: withSecurity(
      loadable(() => import('views/pages/Operations')),
      false,
      [TYPES.OPERATOR, TYPES.ACCOUNTANT],
    ),
    exact: true,
    display: false,
    sitemap: false,
  },
  {
    path: '/operations/geolocation',
    name: 'Geolocation',
    component: withSecurity(
      loadable(() => import('views/pages/Operations')),
      false,
      [TYPES.OPERATOR],
    ),
    exact: true,
    display: false,
    sitemap: false,
  },
  {
    path: '/ride',
    name: 'Ride',
    component: withSecurity(
      loadable(() => import('views/pages/Ride')),
      false,
      [TYPES.OPERATOR, TYPES.ACCOUNTANT, TYPES.MANAGER, TYPES.INDEPENDENT_COURIER],
    ),
    exact: true,
    display: false,
    sitemap: false,
  },
  {
    path: '/cmr/:token',
    name: 'CMR',
    component: loadable(() => import('views/pages/CMR')),
    exact: true,
    sitemap: false,
  },
  {
    path: '/confirmation/:id',
    name: 'Confirmation',
    component: loadable(() => import('views/pages/Confirmation')),
    exact: true,
    sitemap: false,
  },
  {
    path: '/map',
    name: 'Map',
    component: loadable(() => import('views/pages/Map')),
    exact: true,
    sitemap: false,
  },
  {
    path: '/geolocation-map',
    name: 'GeolocationMap',
    component: withSecurity(
      loadable(() => import('views/pages/GeolocationMap')),
      false,
      [TYPES.MANAGER],
      'accessCourierGeolocation',
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/white-label',
    name: 'WhiteLabel',
    component: withSecurity(
      loadable(() => import('views/pages/WhiteLabel')),
      false,
      [TYPES.MANAGER],
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/courier-hours',
    name: 'CourierHours',
    component: withSecurity(
      loadable(() => import('views/pages/CourierHours')),
      false,
      [TYPES.MANAGER],
      'accessTimeManagement',
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/customize',
    name: 'Customize',
    component: withSecurity(
      loadable(() => import('views/pages/Customize')),
      false,
      [TYPES.FREIGHT_FORWARDER],
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: ['/customize/manage-users/:action/:id', '/customize/manage-users/:action'],
    name: 'CustomUsers',
    component: withSecurity(
      loadable(() => import('views/pages/Customize/ManageCustomUsers')),
      false,
      [TYPES.FREIGHT_FORWARDER],
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: withSecurity(
      loadable(() => import('views/pages/Invoices')),
      false,
      [TYPES.ACCOUNTANT],
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/invoices/:id',
    name: 'Invoices Details',
    component: withSecurity(
      loadable(() => import('views/pages/InvoicesDetailsPage')),
      false,
      [TYPES.ACCOUNTANT],
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/profitability-calculation',
    name: 'Profitability Calculation',
    component: withSecurity(
      loadable(() => import('views/pages/ProfitabilityCalculation')),
      false,
      [TYPES.MANAGER],
      'accessProfitabilityCalculator',
    ),
    exact: true,
    sitemap: false,
  },
  {
    path: '/landing-page',
    name: 'Custom landing page',
    component: withSecurity(
      loadable(() => import('views/pages/LandingPage')),
      false,
      [TYPES.MANAGER],
      'accessCustomLandingPage',
    ),
    exact: true,
    sitemap: false,
  },
]

export default routes
